import Column from "../Grid/Column";
import Container from "../Grid/Container";
import Row from "../Grid/Row";

const WelcomeSection = () => {
    return(
        <section className="mt-18 mb-28 maxMd:mt-14 maxMd:mb-12">
            <Container>
                <Row className="justify-between">
                    <Column xl={6} lg={6}>
                        <h2 className="text-h3 maxMd:!text-h3 leading-h3 maxMd:!leading-h3 maxMd:text-center text-primary mb-10 maxMd:mb-8"><span className="font-extrabold">BEZPŁATNĄ</span> obsługę kredytową <br /> Klientów Unidevelopment zapewnia:</h2>
                        <img src="/storage/static/finamax.svg" alt="Finamax" width={448} height={138} className="maxMd:mb-8"/>
                    </Column>
                    <Column xl={6} lg={6}>
                        <p className="text-p leading-p text-text mb-2 maxMd:text-center">Eksperci Kredytowi czekają na Państwa w biurze sprzedaży inwestycji. Zachęcamy do umawiania spotkań w dogodnym dla Państwa terminie, pod poniżej podanymi numerami telefonu:</p>
                        <div className="flex gap-x-4 text-p leading-p text-text mb-1 maxMd:justify-center">
                            <p className="font-extrabold">Telefon:</p>
                            <a href="tel:22 487 58 10">22 487 58 10</a>
                        </div>
                        <div className="flex gap-x-4 text-p leading-p text-text maxMd:justify-center">
                            <p className="font-extrabold">Telefon:</p>
                            <a href="tel:664 329 399">664 329 399</a>
                        </div>
                    </Column>
                </Row>
            </Container>
        </section>
    )
}

export default WelcomeSection;